import {
  groupContainsMakeupRequestsNav,
  type MakeupNavBadge,
} from "@/components/shared/sidebar/makeupNavBadge";
import {
  groupContainsMyTasksNav,
  type UserTasksNavBadge,
} from "@/components/shared/sidebar/userTasksNavBadge";

export function getNavGroupHeaderBadgeCount(
  items: ReadonlyArray<{ href: string }>,
  makeupNavBadge: MakeupNavBadge | null | undefined,
  userTasksNavBadge: UserTasksNavBadge | null | undefined,
): number {
  let total = 0;

  if (
    groupContainsMakeupRequestsNav(items) &&
    (makeupNavBadge?.count ?? 0) > 0
  ) {
    total += makeupNavBadge!.count;
  }

  if (groupContainsMyTasksNav(items) && (userTasksNavBadge?.count ?? 0) > 0) {
    total += userTasksNavBadge!.count;
  }

  return total;
}

export function buildNavGroupHeaderBadgeLabel(
  groupLabel: string,
  count: number,
): string {
  const countLabel = count > 9 ? "9+" : String(count);
  return `${groupLabel} (${countLabel} items need attention)`;
}
